module.exports = __webpack_public_path__ + "img/CluExpress.6da63604.svg";